export const stylePaddingCols: any = { paddingRight: '12px' };
